import React, { useState } from "react";

function InvoiceTypeModal({ isOpen, onClose, onSubmit }) {
  const [formData, setFormData] = useState({
    email: "",
    type: "individual", // individual or organization
    registrationNumber: "",
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!formData.email) {
      alert("Имэйл хаяг оруулна уу");
      return;
    }

    if (formData.type === "organization" && !formData.registrationNumber) {
      alert("Байгууллагын регистрийн дугаар оруулна уу");
      return;
    }

    onSubmit(formData);
    onClose();
  };

  const handleClose = () => {
    setFormData({
      email: "",
      type: "individual",
      registrationNumber: "",
    });
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={handleClose}>
      <div className="modal-content invoice-modal" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header invoice-modal__header">
          <h3>И-баримт</h3>
          <button className="close-button" onClick={handleClose}>
            ×
          </button>
        </div>

        <form onSubmit={handleSubmit} className="modal-form invoice-modal__form">
          <div className="form-group">
            <label htmlFor="email">
              Имэйл хаяг <span className="required">*</span>
            </label>
            <input
              type="email"
              id="email"
              name="email"
              value={formData.email}
              onChange={handleInputChange}
              placeholder="И-мэйл хаягаа энд бичнэ үү"
              required
            />
          </div>

          <div className="form-group">
            <label>
              НӨАТ авах хэлбэр <span className="required">*</span>
            </label>
            <div className="radio-group invoice-modal__type-group">
              <label
                className={`radio-label pill ${formData.type === "individual" ? "selected" : ""}`}
              >
                <input
                  type="radio"
                  name="type"
                  value="individual"
                  checked={formData.type === "individual"}
                  onChange={handleInputChange}
                />
                <div className="radio-content">
                  <span className="radio-icon">
                    <img src="/img/person.png" alt="Individual" />
                  </span>
                  <span className="radio-title">Хувь хүн</span>
                </div>
              </label>
              <label
                className={`radio-label pill ${formData.type === "organization" ? "selected" : ""}`}
              >
                <input
                  type="radio"
                  name="type"
                  value="organization"
                  checked={formData.type === "organization"}
                  onChange={handleInputChange}
                />
                <div className="radio-content">
                  <span className="radio-icon">
                    <img src="/img/apartment.png" alt="Organization" />
                  </span>
                  <span className="radio-title">Байгууллага</span>
                </div>
              </label>
            </div>
          </div>

          {formData.type === "organization" && (
            <div className="form-group">
              <label htmlFor="registrationNumber">
                Регистрийн дугаар <span className="required">*</span>
              </label>
              <input
                type="text"
                id="registrationNumber"
                name="registrationNumber"
                value={formData.registrationNumber}
                onChange={handleInputChange}
                placeholder="1234567890"
                required
              />
            </div>
          )}

          <div className="modal-actions invoice-modal__actions">
            <button type="submit" className="btn-submit invoice-modal__submit">
              Үргэлжлүүлэх
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default InvoiceTypeModal;
